module.exports = __webpack_public_path__ + "assets/icon-bell.06278a24.svg";